<template>
  <div class="resize-panels-arrows">
    <img src="static/img/icon_expand_body.svg" class="resize-panels-arrow resize-panels-arrow--left"/>
    <img src="static/img/icon_expand_body.svg" class="resize-panels-arrow resize-panels-arrow--right"/>
  </div>
</template>

<script>
  export default {
    name: 'resize-panel-arrows'
  }
</script>
<style lang="scss">
  @import '../../assets/sass/grid';

  .resize-panels-arrows {
    user-select: none;
    -webkit-user-select: none;
    opacity: 0;
    transition: opacity .4s ease;
    .resize-panels-arrow {
      position: absolute;
      top: calc(50% + 26px);
      transition: all .4s ease;
      &--left {
        left: calc((50vw - #{$width-xl} / 2) - 28px - 50px);
      }
      &--right {
        right: calc((50vw - #{$width-xl} / 2) - 28px - 50px);
        transform: rotate(180deg);
      }
    }
  }

  .bodyMaximized {
    .resize-panels-arrow {
      transform: rotate(0deg) scale(.5);
      path {
        fill: #c3c3c3;
      }
      &--left {
        left: calc(2.5vw / 2 - 14px);
        transform: rotate(180deg) scale(.5);
        opacity: 1;
      }
      &--right {
        right: calc(2.5vw / 2 - 14px);

      }
    }
  }

  .resizePanelsHovered {
    .resize-panels-arrows {
      opacity: 1;
    }
  }
</style>